import { Container } from 'react-bootstrap';
import '../index.scss';

const Leads = () => {
  return (
    <div className="prmPage" data-testid="prm-leads-page">
      <Container>
        <h1 className="Heading Heading--h5">Leads</h1>
        <p className="Preamble">Leads will be available here soon.</p>
      </Container>
    </div>
  );
};

export default Leads;
